import { render, staticRenderFns } from "./CustomerInsuranceHistory.vue?vue&type=template&id=3eb56220&"
import script from "./CustomerInsuranceHistory.vue?vue&type=script&lang=js&"
export * from "./CustomerInsuranceHistory.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInsuranceHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports